import React, { useState, useEffect } from "react";
import {
  TableContainer,
  Paper,
  Typography,
  Box,
  RadioGroup,
  Radio,
  FormControlLabel,
  TextField,
} from "@mui/material";

import { set } from "lodash";
import {
  validateNumberInput,
  validatePercentageInput,
} from "../../../../utils/validateFields";

function Tables({
  columnWidth,
  heading,
  columnValue,
  title,
  topHeading,
  topheader,
  formValues,
  setErrors,
  errorsindex,
  setFormValues,
  setRowIndex,
  errors,
  disabled,
}) {
  const [columnArray, setColumnArray] = useState([]);

  useEffect(() => {
    const columnLength = columnWidth.split(" ");
    setColumnArray(columnLength);
  }, [columnWidth]);

  const getNestedValue = (obj, path) => {
    return path.split(".").reduce((acc, part) => acc && acc[part], obj);
  };

  const handleChangeRadio = ({ target: { name, value } }) => {
    setFormValues((prev) => {
      const keys = name.split("."); // Assuming `name` is a dot-separated string
      const updatedForm = { ...prev };

      let current = updatedForm;
      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          current[key] = value; // Update the specific field
        } else {
          current[key] = { ...current[key] };
          current = current[key];
        }
      });

      return updatedForm;
    });
  };

  useEffect(() => {
    let newErrors = {};

    columnValue.forEach((item, rowIndex) => {
      if (item.value) {
        heading.slice(1).forEach((headings) => {
          const name = headings.key
            ? `${item.key}.${headings.key}`
            : `${item.key}`;
          newErrors[name] = {
            rowIndex,
            message: "", // Initialize with empty error message
          };
        });
      }
    });

    // Preserve previous errors instead of overriding them

    if (setRowIndex) {
      setRowIndex((prevIndex) => ({
        ...prevIndex,
        ...newErrors,
      }));
    }
  }, []);

  const handleChange = (e, type) => {
    const { name, value } = e.target;

    const numValue =
      type === "percentage" || type === "number"
        ? value?.trim() === "" || isNaN(Number(value))
          ? ""
          : Number(value)
        : value;

    if (type === "number") {
      if (!/^\d*\.?\d*$/.test(value)) {
        return; // Allow decimals but block other characters
      }
    }
    if (type === "percentage") {
      if (!/^\d*\.?\d*$/.test(numValue) || numValue < 0 || numValue > 100) {
        return; // Prevent invalid input
      }
    }

    setFormValues((prevState) => {
      if (!prevState) return {};
      const keys = name.split(".");
      const cleanedPrev = JSON.parse(JSON.stringify(prevState));
      const updatedData = structuredClone(cleanedPrev);

      let currentLevel = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!currentLevel[keys[i]]) {
          currentLevel[keys[i]] = {};
        }
        currentLevel = currentLevel[keys[i]];
      }
      // Update value
      currentLevel[keys[keys.length - 1]] = numValue;

      // currentLevel[keys[keys.length - 1]] = (type==="percentage"||type==="number") ? Number(numValue) : value;

      // Ensure `total`, `male`, and `female` exist before calculations

      let lastPreviousKeys = [];
      let tempData = updatedData;
      for (let i = 0; i < keys.length - 1; i++) {
        if (tempData?.[keys[i]]) {
          if (keys.length >= 5) {
            // If 4 or more keys, store the second key and last-to-previous key
            lastPreviousKeys.push(Object.keys(tempData[keys[i]]));
          }

          tempData = tempData[keys[i]]; // Move deeper
        } else {
          break;
        }
      }

      return updatedData;
    });
  };

  return (
    <Box sx={{ minWidth: 650 }}>
      <Typography
        variant="h6"
        sx={{
          textDecoration: "underline",
          textTransform: "Capitalize",
          fontWeight: "bold",
          margin: "15px 0",
        }}
      >
        {topheader}
      </Typography>
      <Typography
        variant="subtitle1"
        sx={{ fontWeight: "bold", margin: "15px 0" }}
        gutterBottom
      >
        {topHeading}
      </Typography>
      <Typography
        sx={{ marginBottom: "20px", fontWeight: "bold", marginTop: "10px" }}
        variant="body1"
        gutterBottom
      >
        {title}
      </Typography>
      <TableContainer
        component={Paper}
        sx={{ maxWidth: "100%", borderRadius: "10px" }}
      >
        <Box>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: columnWidth,
              background: " #1C486B",
              borderBottom: "1px solid #ddd",
              borderTop: "1px solid #ddd",
            }}
          >
            {heading.map((item) => {
              return (
                <Typography
                  sx={{
                    height: "100%",
                    // fontWeight: "bold",
                    padding: "8px 12px",
                    color: "#FFFFFF",
                    paddingY: "10px",
                    borderRight: "1px solid #DBDBDB ",
                    display: "flex",
                    flexDirection: "row",
                  }}
                >
                  {item.title}
                </Typography>
              );
            })}
          </Box>

          {columnValue.map((item, rowIndex) => {
            if (item.value) {
              return (
                <Box
                  key={item._id}
                  sx={{
                    display: "grid",
                    gridTemplateColumns: columnWidth,
                    borderBottom: "1px solid #ddd",
                    justifyContent: "center",
                  }}
                >
                  {/* Render Typography for the row */}
                  <Typography
                    sx={{
                      borderRight: "1px solid #DBDBDB",
                      fontSize: "15px",
                      padding: "10px",
                    }}
                  >
                    {item.value}
                  </Typography>
                  {heading.length > 0 &&
                    heading.slice(1).map((headings, index) => {
                      const name = headings.key
                        ? `${item.key}.${headings.key}`
                        : `${item.key}`;

                      // Split the name into parts using '.' as a delimiter
                      const matchResult = name.split(".");

                      // Ensure the split result is valid
                      if (matchResult.length < 2) {
                        // console.error(`Invalid name format: ${name}`);
                        return null; // Skip this iteration if the name format is invalid
                      }

                      const [mainKey, subKey, fieldKey, field1Key] =
                        matchResult;
                      return (
                        <>
                          <TextField
                            disabled={disabled}
                            key={index} // Adding a key for mapping
                            variant="standard"
                            sx={{
                              // backgroundColor:
                              //   isPercentage || isTotal || isTotalRow
                              //     ? "#EFEFEF"
                              //     : "",
                              borderRight: "1px solid #DBDBDB",
                              padding: "8px 12px",
                              "& .MuiInputBase-root": {
                                padding: 0, // Align with grid cells
                              },
                            }}
                            name={name}
                            type="text"
                            InputProps={{ disableUnderline: true }}
                            fullWidth
                            size="small"
                            value={
                              fieldKey
                                ? formValues?.[mainKey]?.[subKey]?.[fieldKey]?.[
                                    field1Key
                                  ]
                                : formValues?.[mainKey]?.[subKey] ?? ""
                            }
                            placeholder={
                              field1Key === "remark"
                                ? "Enter Text"
                                : "Enter Number"
                            }
                            onChange={(e) =>
                              handleChange(
                                e,
                                headings.type ? headings.type : "number"
                              )
                            }
                          />
                        </>
                      );
                    })}
                </Box>
              );
            }
          })}
        </Box>
      </TableContainer>
      {Array.isArray(errors) && errors.length > 0
        ? Object.entries(
            errors?.reduce((acc, item) => {
              if (!acc[item.rowIndex]) {
                acc[item.rowIndex] = [];
              }
              acc[item.rowIndex].push(
                item.fieldName === "undefined"
                  ? "% of your plants and offices"
                  : item.fieldName
              );
              return acc;
            }, {})
          ).map(([rowIndex, fields], idx) => (
            <Typography
              variant="body2"
              color="error"
              key={`error-${rowIndex}-${idx}`}
              style={{
                lineHeight: "1.2",
                margin: "2px 0",
                color: "#d34040",
                fontSize: "10px",
                fontStyle: "italic",
                marginTop: "0px",
              }}
            >
              Row {rowIndex} Missing fields: - {fields.join(", ")}
              {/* Row {rowIndex}: {fields.join(", ")} */}
            </Typography>
          ))
        : null}
    </Box>
  );
}

export default Tables;
